<script>

export default {
  name: 'loading-indicators',
  install(Vue) {
    /** Set global loading indicator */
    Object.defineProperty(Vue.prototype, '$loading', {
      get() {
        return this.$root.loading
      },
      set(value) {
        this.$root.loading = value
      }
    })

    /** Set global mask */
    Object.defineProperty(Vue.prototype, 'masked', {
      get() {
        return this.$root.masked
      },
      set(value) {
        this.$root.masked = value
      }
    })
  },

  /**
   * Hooks for loading indicators
   *
   */
  hook: {
    start(request) {
      let spots = []

      if (request && request.url) {
        let url = request.url.replace('{ENV}', '')
        url = url.split('?')[0]
        spots = global.jQuery(`[endpoint="${url}"]`)
      }

      if (spots.length) {
        spots.addClass('loading')
      } else {
        ;((this.$loading ? this : null) || global.app).$loading = true
      }
    },
    stop(response) {
      let url = ''

      ;((this.$loading ? this : null) || global.app).$loading = false

      if (response && response.config.url) {
        global.jQuery(`[endpoint^="${response.config.url}"]`).removeClass('loading')

        url = response.config.url
                .replace(response.config.baseURL, '')
                .replace(`://${global.app.api._env}`, '://')
                .replace(`//${global.app.api._env}`, '//')
                .replace(~global.app.api.env.indexOf('//evedonline') ? /\/\/evedonline\./ : /\/\/(.+)evedonline\./, '//local.evedonline.')

        url = url.split('?')[0]
        global.jQuery(`[endpoint^="${url}"]`).removeClass('loading')
      } else {
        if (response && response.request.responseURL) {
          global.jQuery(`[endpoint^="${response.request.responseURL}"]`).removeClass('loading')

          url = response.request.responseURL
            .replace(response.config.baseURL, '')
            .replace(/\/\/(.+)evedonline\./, ~global.app.api.env.indexOf('//evedonline') ? '//evedonline.' : '//local.evedonline.')

          global.jQuery(`[endpoint^="${url}"]`).removeClass('loading')
        }
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/core/loading-indicators/index.vue